import {createContext} from 'react';

import {TWebsocketClient} from './use-websocket-client';

interface IWebsocketsContextArgs {
    wsInstance?: TWebsocketClient;
}

export const WebsocketsContext = createContext<IWebsocketsContextArgs>({});
